import { Directive, Input, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[passwordValidation]',
  host: {'(input)': 'onBlur($event)'}
})
export class PasswordValidationComponent {
  @Input('passwordValidation') repeat: boolean;
  @Input() checkPassword: string;
  @Output() validation: EventEmitter<any> = new EventEmitter();
  @Output() match: EventEmitter<any> = new EventEmitter();
  password: string;
  repeatPassword: string;
  minPWLength: number = 8;
  timeout: any;

  onBlur($event) {
    const target = $event.target;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (target.value) {
        const valid = this.repeat ?
          this.checkMatch(this.checkPassword, target.value) :
          this.validate(target.value);
        valid ? target.classList.add('valid') : target.classList.remove('valid');
        this.validation.emit(valid);
        this.match.emit(valid);
      } else {
        this.validation.emit(true);
        this.match.emit(true);
      }
    }, 1000);
  }

  validate(password) {
    if (password) {
      return password.length > this.minPWLength - 1;
    }
  }

  checkMatch(password, repeat) {
    return password === repeat;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/password-validation.component.ts